import React from 'react'
import axios from 'axios'
import Error from '../_error';
import dynamic from 'next/dynamic'
const SuburbPage = dynamic(() => import('../../components/suburb/SuburbPage'))
const CityPage = dynamic(() => import('../../components/city/CityPage'))

function Suburb ({ page, ...props }) {
  // if (page === '404') return <Error statusCode={404}/>
  if (page === 'suburb') return !props.suburb.hidden ? <SuburbPage key={props.suburb.id} {...props}/> : <Error statusCode={404}/>
  else if (page === 'city') return !props.city.hidden ? <CityPage key={props.city.id} {...props}/> : <Error statusCode={404}/>
}

Suburb.getInitialProps = async (ctx) => {
  const { suburbId } = ctx.query
  const res = ctx.res

  if (suburbId.match(/(\d{4})$/)) {
    const [
      suburb,
      clinic,
      nextEvents,
      reviewData,
      popularStreets,
    ] = await Promise.all([
      axios.get(`${process.env.REACT_APP_API_URL}/suburbs/${suburbId}`, {
        params: {
          _ignoreFields: 'geometry',
        }
      })
        .catch(e => {
          if (e.response && e.response.status === 404) return { data: null }
          else throw e
        })
        .then(r => r.data),
      axios.get(`${process.env.REACT_APP_API_URL}/suburbs/${suburbId}/_clinic`)
        .catch(e => ({ data: null }))
        .then(r => r.data),
      axios.get(`${process.env.REACT_APP_API_URL}/suburbs/${suburbId}/_appointments/_next`)
        .catch(e => ({ data: [] }))
        .then(r => r.data),
      axios.get(`${process.env.REACT_APP_API_URL}/suburbs/${suburbId}/_reviews`)
        .catch(e => ({ data: { items: [], count: 0, average: 0 } }))
        .then(r => r.data),
      axios.get(`${process.env.REACT_APP_API_URL}/suburbs/${suburbId}/_streets`)
        .catch(e => ({ data: { items: [], count: 0, average: 0 } }))
        .then(r => r.data.items),
    ])

    if (!suburb) {
      if (res) res.statusCode = 404;
      throw new Error('Not found')
      // return { page: '404' }
    }

    if (res) {
      if (suburb.redirect) {
        res.setHeader('Location', `${process.env.REACT_APP_APP_URL}/physiotherapy/${suburb.redirect}`)
        res.statusCode = 301
        res.end()
        return {}
      }
      if (suburb.longTermCache) {
        res.setHeader('Cache-Control', 'public, max-age=3600, s-max-age=604800, stale-while-revalidate=2592000')
      } else {
        res.setHeader('Cache-Control', 'public, max-age=30, stale-while-revalidate=864000')
      }
    }

    return {
      page: 'suburb',
      suburb,
      clinic,
      reviewData,
      nextEvents,
      popularStreets,
    }
  } else {
    const [
      city,
      suburbs,
      cities,
      popularStreets,
    ] = await Promise.all([
      axios.get(`${process.env.REACT_APP_API_URL}/cities/${suburbId}`)
        .catch(e => {
          if (e.response && e.response.status === 404) return { data: null }
          else throw e
        })
        .then(r => r.data),

      axios.get(`${process.env.REACT_APP_API_URL}/suburbs`, {
        params: {
          city: suburbId,
          includeHidden: 'true',
          limit: 300,
          _fields: 'id,name,hidden,clinicId,state,postcode',
        }
      }).catch(e => {
        return { data: { items: [] } }
      }).then(r => r.data.items),

      axios.get(`${process.env.REACT_APP_API_URL}/cities`, {
        params: {
          exclude: suburbId,
          priorityOrder: 'true',
          _fields: 'id,name',
        }
      }).then(r => r.data.items),

      axios.get(`${process.env.REACT_APP_API_URL}/cities/${suburbId}/_streets`)
        .catch(e => {
          console.log(e)
          return { data: { items: [], count: 0, average: 0 } }
        })
        .then(r => r.data.items),
    ])

    if (!city) {
      if (res) res.statusCode = 404;
      throw new Error('Not found')
      return { page: '404' }
    }

    if (res) {
      if (city.redirect) {
        res.setHeader('Location', `${process.env.REACT_APP_APP_URL}/physiotherapy/${city.redirect}`)
        res.statusCode = 301
        res.end()
        return {}
      }
      res.setHeader('Cache-Control', 'public, max-age=3600, s-max-age=604800, stale-while-revalidate=2592000')
    }

    return {
      page: 'city',
      city,
      suburbs,
      cities,
      popularStreets,
    }
  }
}

export default Suburb
